export default __webpack_public_path__ + "static/media/manageit-logo-blue.47bd2587.svg";